<template>
  <div class="wrap">
    <!-- start 此空div不能删除，否则会导致燎原活动不渲染 -->
    <div>
      <div class="active" v-for="item in marketCenterLists" :key="item.ruleId" @click="handleJumpBig(item)" v-has="item.isShowCode">
        <div class="content g-flex-sb">
          <div class="left g-flex-c">
            <img :src="item.banner" alt="" />
          </div>
          <div class="center">
            <p class="title">{{item.activityName}}</p>
            <p class="word">{{item.overview}}</p>
          </div>
          <div class="right g-flex-column-c">
            <el-button class="btn" v-if="item.status === 1" @click.stop="handleSignLiaoyuan(item)">立即报名</el-button>
            <el-button class="btn-fin" v-if="item.status === 2" @click.stop="handleSignLiaoyuan(item)">活动已结束</el-button>
            <el-button class="btn-check" v-if="item.status === 3" @click.stop="handleSignLiaoyuan(item)">查看已报名</el-button>
            <!-- <div class="shopOil g-flex-c"><img src="https://web.nlktj.com/ty/merchant-h5/fire.png" alt="" />{{item.joinedGasCount || 0}}座油站累计参加</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="active" v-for="item in acticeList" :key="item.id" @click="handleJumpBig(item, item.tysj_trade_type)" v-has="item.isShowCode" v-show="item.isShow !== false">
      <div class="content g-flex-sb">
        <div class="left g-flex-c">
          <img :src="item.banner" alt="" />
        </div>
        <div class="center">
          <p class="title">{{item.title}}</p>
          <p class="word">{{item.word}}</p>
          <p class="tip" v-if="![9, 11, 12, 13, 14, 17, 16, 18].includes(item.id)">
            <span>{{item.tipOne}}</span>
            <img src="https://web.nlktj.com/ty/merchant/active/three.png" alt="" />
            <span style="color: #E73934">{{item.tipSec}}</span>
            <span>{{item.tipThird}}</span><img src="https://web.nlktj.com/ty/merchant/active/three.png" alt="" />
            <span style="color: #E73934">{{item.tipFou}}</span>
          </p>
          <div class="label-wrap-luck" v-if="[16, 11].includes(item.id)">
            <div class="label" v-for="(itemLabel, index) in item.label" :key="index">
              <span>{{itemLabel.labelName}}<img :class="[itemLabel.labelName === '活动标签' ? 'popa-img' : 'pop-img']" :src="itemLabel.labelUrl" alt="" /></span>
            </div>
          </div>
          <p class="tip" v-if="item.id === 12"><el-link type="primary" @click.stop="showSign = true">签约入口</el-link></p>
        </div>
        <div class="right g-flex-column-c">
          <template v-if="item.id === 8">
            <el-button v-if="item.isJoin" class="btn" @click.stop="canJoinApi(item.jumpSignUrl, item.id)">立即报名</el-button>
            <el-button v-else class="check-btn" type="primary" plain  @click.stop="checkWaterNum">查看已报名</el-button>
          </template>
          <template v-else-if="item.id === 11">
            <el-button class="btn" v-if="item.btnType === 3" @click.stop="handleSignLuck(item.jumpSignUrl, 'btnGo')">立即报名</el-button>
            <el-button class="btn-fin" v-else-if="item.btnType === 1" @click.stop="handleFin">活动已结束</el-button>
            <el-button class="btn-check" v-else @click.stop="checkTreasureNum">查看已报名</el-button>
          </template>
          <template v-else-if="item.id === 12">
            <el-button class="btn" v-if="item.btnType === 1" @click.stop="handleOrder(item.jumpSignUrl)">立即报名</el-button>
            <el-button class="btn-fin" v-else-if="item.btnType === 2" @click.stop="handleFin">活动已结束</el-button>
            <el-button class="btn-check" v-else @click.stop="checkOrder">查看已报名</el-button>
          </template>
          <template v-else-if="[14, 17, 18].includes(item.id)">
            <el-button class="btn">立即报名</el-button>
          </template>
          <template v-else-if="item.id === 16">
            <el-button class="btn" v-if="item.btnType === 1" @click.stop="handleSignJourney(item.jumpSignUrl, item.btnType)">立即报名</el-button>
            <el-button class="btn-fin" v-else-if="item.btnType === 2" @click.stop="handleSignJourney(item.jumpSignUrl, item.btnType)">活动已结束</el-button>
            <el-button class="btn-check" v-else @click.stop="handleSignJourney(item.jumpSignUrl, item.btnType)">查看已报名</el-button>
          </template>
          <template v-else>
            <el-button class="btn" @click.stop="handleSign(item.jumpSignUrl, item.id)">立即报名</el-button>
          </template>
          <div v-if="![13, 14, 17, 16, 18].includes(item.id)" class="shopOil g-flex-c"><img src="https://web.nlktj.com/ty/merchant-h5/fire.png" alt="" />{{item.signCount || 0}}座油站累计参加</div>
        </div>
      </div>
      <div class="label-wrap" v-if="[7, 9].includes(item.id)">
        <div class="label" v-for="(itemLabel, index) in item.label" :key="index">
          <span>{{itemLabel.labelName}}<img :class="[itemLabel.labelName === '活动标签' ? 'popa-img' : 'pop-img']" :src="itemLabel.labelUrl" alt="" /></span>
        </div>
      </div>
    </div>
    <agreement ref="agreement" :router="router" :type="type"/>
    <signForm v-if="showSign" @close="showSign = false"></signForm>
  </div>
</template>
<script>
// 活动越来越乱，代码拓展越来越来扯淡。
import agreement from './centerShowComponents/agreement'
import { marketCenter, marketCenterList, canJoin, activityLabel, joinCompanyNum, check, checkGasSale, getLuckyDrawPic, getLuckDrawApplicantsCount, getActivityStatus, canJoinOrder } from '@/api/marketPromotion'
import signForm from './components/signForm.vue'
import { mapState } from 'vuex'

export default {
  components: {
    agreement,
    signForm
  },
  data () {
    const _this = this
    return {
      router: '',
      type: null,
      // menuActive: ['water', 'daySpecial', 'limitShop', 'persisMarketBtn'], // 菜单展示逻辑
      acticeList: [
        {
          id: 16,
          jumpUrl: '/promotion/journeySubsidy',
          jumpSignUrl: '/promotion/journeySubsidy',
          banner: `${_this.$ossUrl}persisMarket/journeySubsidy.png`,
          title: '路程补贴',
          word: '抢夺站外潜在加油消费',
          isShowCode: 'journeySubsidy',
          btnType: 1, // 加油冲单按钮展示状态  1-立即报名。 2-活动已结束 3-查看已报名
          label: [{ labelName: '提前锁客' }],
          isShow: false
        },
        {
          id: 12,
          jumpUrl: '/promotion/comeOrder',
          jumpSignUrl: '/promotion/comeOrder',
          banner: `${_this.$ossUrl}persisMarket/come-order.png`,
          title: '加油冲单',
          word: '油站通过参加加油冲单大奖活动，达到奖励档次后，团油给予油站相应的现金奖励，冲的越多，奖励越高。',
          // tipOne: '预估曝光',
          // tipSec: '30%~50%',
          // tipThird: '预估流水',
          // tipFou: '15%+',
          signCount: 0,
          btnType: 3, // 加油冲单按钮展示状态  1-立即报名。 2-活动已结束 3-查看已报名
          isShowCode: 'comeOrder',
          label: [],
          tysj_trade_type: 1
        },
        {
          id: 8,
          jumpUrl: '/promotion/sendWater',
          jumpSignUrl: '/promotion/center',
          banner: `${_this.$ossUrl}persisMarket/perOne.png`,
          title: '加油送箱水',
          word: '油站通过参加一箱水活动，团油给予油站相应的平台导流能力，吸引用户到站加油，加油后可获的一箱水。',
          tipOne: '新客流量曝光',
          tipSec: '50%+',
          tipThird: '新客订单',
          tipFou: '25%+',
          isJoin: false,
          signCount: 0,
          isShowCode: 'water',
          tysj_trade_type: 0
        },
        {
          id: 7,
          jumpUrl: '/promotion/daySpecial',
          jumpSignUrl: '/promotion/daySpecialSign',
          banner: `${_this.$ossUrl}persisMarket/perThird.png`,
          title: '天天特价',
          word: '商家通过额外降价的方式以天为单位参加活动，平台引流宣传助力商家活动效果提升。',
          tipOne: '预估曝光',
          tipSec: '30%~50%',
          tipThird: '预估流水',
          tipFou: '15%+',
          signCount: 0,
          isShowCode: 'daySpecial',
          label: [],
          tysj_trade_type: 1
        },
        {
          id: 9,
          jumpUrl: '/promotion/limitShop',
          jumpSignUrl: '/promotion/limitShopSign',
          banner: `${_this.$ossUrl}persisMarket/perSec.png`,
          title: '限时秒杀',
          word: '商家通过额外降价的方式以时间段为单位参加活动，平台引流宣传助力商家活动效果提升。',
          tipOne: '预估曝光',
          tipSec: '50%~70%',
          tipThird: '预估流水',
          tipFou: '20%+',
          signCount: 0,
          isShowCode: 'limitShop',
          label: [],
          tysj_trade_type: 2
        },
        {
          id: 11,
          jumpUrl: '/promotion/treasure',
          jumpSignUrl: '/promotion/treasure',
          banner: `${_this.$ossUrl}persisMarket/perFou.png`,
          title: '抽奖宝',
          word: '商家通过额外降价的方式以时间段为单位参加活动，平台引流宣传助力商家活动效果提升。',
          // tipOne: '预估曝光',
          // tipSec: '50%~70%',
          // tipThird: '预估流水',
          // tipFou: '20%+',
          signCount: 0, // 油站数量
          btnType: 3, // 抽奖宝按钮展示状态
          isShowCode: 'treasureBtn',
          label: [{ labelName: '限时报名' }],
          tysj_trade_type: 3
        },
        {
          id: 13,
          jumpUrl: '/promotion/treasure',
          jumpSignUrl: '/promotion/treasure',
          banner: `${_this.$ossUrl}persisMarket/perOne.png`,
          title: '天天神券',
          word: '油站的满减优惠券活动，油站流水增长好帮手。',
          // tipOne: '预估曝光',
          // tipSec: '50%~70%',
          // tipThird: '预估流水',
          // tipFou: '20%+',
          // signCount: 0, // 油站数量
          btnType: 3, // 抽奖宝按钮展示状态
          isShowCode: 'ttsqBtn',
          label: [{ labelName: '立即报名' }],
          tysj_trade_type: 3
        },
        {
          id: 14,
          jumpUrl: '/promotion/marketing?origin=growthPlan',
          jumpSignUrl: '/promotion/marketing?origin=growthPlan',
          banner: `${_this.$ossUrl}persisMarket/market.png`,
          title: '增长计划',
          word: '油站通过提供营销折扣，平台依托DeepSeek算法大模型，精准匹配流量，完美提升油站销量。',
          isShowCode: 'growthPlan',
          label: [],
          isShow: false
        },
        {
          id: 17,
          jumpUrl: '/promotion/marketing?origin=gatheringPlan',
          jumpSignUrl: '/promotion/marketing?origin=gatheringPlan',
          banner: `${_this.$ossUrl}persisMarket/dianjin.png`,
          title: '点金计划',
          word: '油站提供营销折扣，平台为您精准引流、专属本站锁客完单券包，提升站内销量同时赚取新/老客分佣。',
          isShowCode: 'gatheringPlan',
          label: [],
          isShow: false
        },
        {
          id: 18,
          jumpUrl: '/promotion/marketing?origin=customerLock',
          jumpSignUrl: '/promotion/marketing?origin=customerLock',
          banner: `${_this.$ossUrl}persisMarket/customerLock.png`,
          title: '锁客宝',
          word: '油站提供营销折扣，平台为您精准引流、专属锁客券包与复购提醒，提高站内销量。',
          isShowCode: 'customerLock',
          label: [],
          isShow: false
        }
      ],
      marketCenterLists: [],
      showSign: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    isCompany () {
      return this.userInfo.companyId
    }
  },
  mounted () {
    this.$track.pageViewEvent('商户-活动广场', '1632832575')
    console.log('userInfo>>>>>>>>>>>>>>', this.userInfo)
    this.marketCenterApi()
    this.marketCenterListApi()
    this.activityLabelApi()
    this.joinCompanyNumApi()
    this.getLuckyDrawPicApi()
    this.getLuckDrawApplicantsCountApi()
    this.getActivityStatusApi()
    // this.getMarketingCenterApi()
  },
  methods: {
    // 大块跳转
    async handleJumpBig (item, type) {
      if (item.id === 13) return
      this.$track.clickEvent('活动详情', 1632832577, { tysj_trade_type: type })
        // 抽奖宝活动已结束
      if (item.id === 11 && this.acticeList[this.acticeList.findIndex(_item => _item.id === 11)].btnType === 1) {
        this.handleFin()
      } else if (item.id === 12 && this.acticeList[this.acticeList.findIndex(_item => _item.id === 12)].btnType === 1) {
        // 商户重单-立即报名-点击大块跳转
        const resGasSale = await checkGasSale()
        if (!resGasSale.result) {
          return this.$message.info('未查询到油站MD,请联系您的客户经理')
        }
        // 是否参加过
        const { result } = await canJoinOrder()
        if(result.status === 2) { return this.$message.info('该活动目前已结束，请下期及时报名参加') }
        this.$router.push({ path: item.jumpUrl, query: { ruleId: result.ruleId } })
      } else if (item.id === 12 && this.acticeList[this.acticeList.findIndex(_item => _item.id === 12)].btnType === 2) {
        // 商户重单-活动已经结束-点击大块跳转
        this.handleFin()
      } else if (item.id === 12 && this.acticeList[this.acticeList.findIndex(_item => _item.id === 12)].btnType === 3) {
        // 商户重单-查看报名状态-点击大块跳转
        // this.$router.push({ path: '/promotion/activeList' })
        this.$router.push({ path: '/promotion/comeOrder' })
      } else if (item.id === 19) {
        this.handleSignLiaoyuan(item)
      } else {
        this.$router.push({ path: item.jumpUrl })
      }
    },
    // 报名跳转
    async handleSign (router, id) {
      if (id === 13) {
        this.$message.error('请联系您所在城市业务经理进行报名')
        return
      }
      this.$track.clickEvent('立即报名', 1632832576, { tysj_trade_type: id === 7 ? 1 : 2 })
      const resGasSale = await checkGasSale()
      if (!resGasSale.result) {
        return this.$message.info('未查询到人站关系，继续报名会失败，请联系您的客户经理')
      }
      this.$router.push({ path: router })
      this.router = router
      this.type = id
    },
    // 抽奖宝立即报名跳转
    async handleSignLuck (router, btnGo) {
      this.$track.clickEvent('立即报名', 1632832576, { tysj_trade_type: 3 })
      const resGasSale = await checkGasSale()
      if (!resGasSale.result) {
        return this.$message.info('未查询到油站MD,请联系您的客户经理')
      }
      this.$router.push({ path: router, query: { btnGo } })
    },
    // 路程补贴立即报名跳转
    async handleSignJourney (router, btnType) {
      this.$router.push({ path: router, query: { btnType } })
    },
    // 燎原活动立即报名跳转
    handleSignLiaoyuan (item) {
      const { jumpSignUrl, ruleId, status: btnType } = item
      this.$router.push({ path: jumpSignUrl, query: { ruleId, btnType } })
    },
    // 抽奖宝活动已结束
    handleFin () {
      this.$message.info('该活动目前已结束，请下期及时报名参加')
    },
    // 获取标签接口
    async activityLabelApi () {
      try {
        const { code, result } = await activityLabel()
        if(code !== 200) return
        result.forEach(item => {
          if (item.activityType === 7) {
            this.acticeList[this.acticeList.findIndex(_item => _item.id === 7)].signCount = item.list
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 获取天天特价，限时秒杀油站数量接口
    async joinCompanyNumApi () {
      try {
        const { code, result } = await joinCompanyNum()
        if(code !== 200) return
        result.forEach(item => {
          if (item.activityType === 7) {
            this.acticeList[this.acticeList.findIndex(_item => _item.id === 7)].signCount = item.joinActivityCount
          } else {
            this.acticeList[this.acticeList.findIndex(_item => _item.id === 9)].signCount = item.joinActivityCount
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 送水的点击按钮是否可以参加
    async canJoinApi (router, id) {
      this.$track.clickEvent('立即报名', 1632832576, {
        tysj_trade_type: 0
      })
      try {
        // 人站关系查询
        const resGasSale = await checkGasSale()
        if (!resGasSale.result) {
          return this.$message.info('未查询到人站关系，继续报名会失败，请联系您的客户经理')
        }
        // 是否参加过
        const { result } = await canJoin({ activityType: id })
        if(!result) {
          return this.$message.info('您已经参与过')
        }
        // 如果已经看过协议了，就不用看了，直接跳转到列表页
        const resSigned = await check({ activityType: id }) // 7-天天特价 8-加油送水 9-限时秒杀
        if(resSigned.result.signed) {
          this.$router.push({ path: router})
        } else {
          this.$refs.agreement.init(resSigned.result.title, resSigned.result.content)
        }
        this.router = router
        this.type = id
      } catch (error) {
        console.log(error)
      }
    },
    // 送水,加油冲单，是否参加，油站数量
    async marketCenterApi () {
      try {
        const activityTypes = '8,12,14,17,16,18'
        const { code, result: { dtoList = [] } } = await marketCenter({ activityTypes })
        if (code !== 200) return
        for (var i = 0; i<dtoList.length; i++) {
          for (var j = 0; j<this.acticeList.length; j++) {
            if (dtoList[i].activityType === this.acticeList[j].id) {
              this.acticeList[j].signCount = dtoList[i].joinedGasCount
              this.acticeList[j].btnType = dtoList[i].status
              if ([14, 17, 18].includes(dtoList[i].activityType) && dtoList[i].status === 1) {
                this.acticeList[j].isShow = true
              }
              if ([16].includes(dtoList[i].activityType) && this.isCompany) {
                this.acticeList[j].isShow = true
              }
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async marketCenterListApi () {
      try {
        const { code, result: { dtoList = [] } } = await marketCenterList({ activityTypes: 19 })
        if (code !== 200) return
        this.marketCenterLists = dtoList.map(item => ({
          ...item,
          id: item.activityType,
          jumpUrl: '/promotion/liaoyuanActivity',
          jumpSignUrl: '/promotion/liaoyuanActivity',
          banner: 'https://web.nlktj.com/ty/merchant/active/img-liaoyuan-banner.png',
          isShowCode: 'liaoyuanActivity'
        }))
      } catch (error) {
        console.log(error)
      }
    },
    // 抽奖宝图片和简介
    async getLuckyDrawPicApi () {
      try {
        const { code, result } = await getLuckyDrawPic()
        if(code !== 200) return
        this.acticeList[this.acticeList.findIndex(_item => _item.id === 11)].banner = result.drawCover
        this.acticeList[this.acticeList.findIndex(_item => _item.id === 11)].word = result.drawDesc
       } catch (error) {
        console.log(error)
      }
    },
    // 抽奖宝油站数量
    async getLuckDrawApplicantsCountApi () {
      try {
        const { code, result } = await getLuckDrawApplicantsCount()
        if(code !== 200) return
        this.acticeList[this.acticeList.findIndex(_item => _item.id === 11)].signCount = result
       } catch (error) {
        console.log(error)
      }
    },
    // 抽奖宝按钮展示逻辑
    async getActivityStatusApi () {
      try {
        const { code, result } = await getActivityStatus()
        if(code !== 200) return
        this.acticeList[this.acticeList.findIndex(_item => _item.id === 11)].btnType = result
       } catch (error) {
        console.log(error)
      }
    },
    checkWaterNum () {
      this.$track.clickEvent('查看已报名', 1632832576, { tysj_trade_type: 0 })
      this.$router.push({ path: '/promotionAudit/myPromotion' })
    },
    checkTreasureNum () {
      this.$track.clickEvent('查看已报名', 1632832576, { tysj_trade_type: 3 })
      this.$router.push({ path: '/promotionAudit/myPromotion',  query: { id: 11 }  })
    },
    /* 商户冲单方法 */
    // 商户冲单立即报名预览按钮
    async handleOrder (url) {
      const resGasSale = await checkGasSale()
      if (!resGasSale.result) {
        return this.$message.info('未查询到油站MD,请联系您的客户经理')
      }
      // 是否参加过
      const { result } = await canJoinOrder()
      if(result.status === 2) { return this.$message.info('该活动目前已结束，请下期及时报名参加') }
      this.$router.push({ path: url, query: { ruleId: result.ruleId }})
    },
    // 商户冲单查看已报名
    checkOrder () {
      this.$router.push({ path: '/promotion/activeList' })
    }
  }
}
</script>
<style lang="less" scoped>
.wrap{
  width: 100%;
  padding: 10px;
  .active:nth-child(1){
    margin-top: 25px;
  }
  .active{
    width: 100%;
    padding: 10px;
    background: #fff;
    margin-top: 20px;
    transition: all .3s;
  }
  .active:hover{
    transform:scale(1.01, 1.01);
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.3);
    cursor: pointer;
  }
  .content{
    .left{
      width: 20%;
      height: 120px;
      >img{
        display: block;
        width: 196px;
        height: 110px;
      }
    }
    .center{
      width: 60%;
      height: 102px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      >P{
        margin: 0;
        padding: 0;
      }
      .title{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .word{
        margin-top: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .tip{
        margin-top: 25px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333333;
        >span{
          margin-right: 30px;
        }
         >span:nth-child(1), >span:nth-child(4){
          margin-right: 25px;
        }
        >img{
          display: inline-block;
          width: 8px;
          height: 6px;
          margin: 0 3px 3px 0;
        }
      }
    }
    .right{
      width: 20%;
      height: 120px;
      .check-btn{
        width: 148px;
        height: 46px;
        color: #fff;
        background: #3377FF;
      }
      .btn{
        width: 148px;
        height: 46px;
        color: #fff;
        background: #3377FF;
      }
      .btn-fin{
        width: 148px;
        height: 46px;
        background: #3377FF;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        opacity: 0.5;
      }
      .btn-check{
        width: 148px;
        height: 46px;
        border-radius: 4px;
        border: 1px solid #3377FF;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1B74FF;
      }
      .shopOil{
        margin-top: 5px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
        >img{
          display: block;
          width: 12px;
          height: 16px;
          margin-right: 10px;
        }
      }
    }
  }
  .label-wrap, .label-wrap-luck{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0 20%;
  }
  .label{
    margin: 2px 10px 0 0;
    >span{
      display: flex;
      align-items: center;
      padding: 2px 10px;
      height: 25px;
      color: #FF7E3C;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      background: #FFF3E7;
      border-radius: 4px;
      transition: all .3s;
      .popa-img {
        transition: all .3s;
        position: absolute;
        display: none;
        max-width: 340px;
        height: 314px;
        top: -146px;
        left: 90%;
      }
      .pop-img{
        transition: all .3s;
        position: absolute;
        display: none;
        max-width: 300px;
        height: 464px;
        top: -221px;
        left: 90%;
      }
    }
    >span:hover {
      position: relative;
      background: #FFDCBA;
    }
    >span:hover .pop-img{
      transition: all .3s;
      display: block;
      z-index: 10000;
    }
    >span:hover  .popa-img{
      transition: all .3s;
      display: block;
      z-index: 10000;
    }
  }
  .label-wrap-luck{
    padding: 0 0;
    margin-top: 20px
  }
}
</style>